// extracted by mini-css-extract-plugin
module.exports = {"container":"SelectMetricsPanel_container__2qtbJ","metrics":"SelectMetricsPanel_metrics__15XIN"};